<template>
    <div class="c-experience-home">
        <div class="c-video-bg-box">
            <div class="cd-video-inner">
                <video id="bannerVideo" autoplay muted loop height="590">
                    <source src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/home/experience-home-video-bg.mp4" />
                </video>
                <span class="video-mask is-01"></span>
                <span class="video-mask is-02"></span>
            </div>
        </div>
        <LayoutContent>
            <div class="c-experience-box">
                <div class="experience-content">
                    <p class="cd-content-text">
                        {{ $t("main:GVoice为您提供") }}<span class="is-import">{{ $t("main:全方位") }}</span
                        >{{ $t("main:的") }}<br />{{ $t("main:语音服务") }}
                    </p>
                    <div class="cd-button-box">
                        <Button size="large" type="primary" :adaptation="true">{{ $t("main:立即体验") }}</Button>
                    </div>
                </div>
            </div>
        </LayoutContent>
    </div>
</template>

<script>
import LayoutContent from "@/components/UI/LayoutContent.vue";
import Button from "@/components/UI/Button.vue";
export default {
    name: "ExperienceHome",
    components: { LayoutContent, Button },
};
</script>

<style scoped lang="less">
@import "/web/src/assets/css/theme.less";
.c-experience-home {
    padding-left: 24px;
    padding-right: 24px;
    background: #120b2c;
    position: relative;
    overflow: hidden;
    &::before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        height: 72%;
        background-image: linear-gradient(#151829, rgba(21, 24, 41, 0), rgba(21, 24, 41, 0));
        z-index: 2;
    }
    &::after {
        content: "";
        position: absolute;
        left: -10%;
        right: -10%;
        bottom: -56%;
        height: 90%;
        background-image: radial-gradient(rgba(78, 103, 255, 0.4) 8%, rgba(78, 103, 255, 0) 68%, rgba(255, 255, 255, 0) 72%);
        z-index: 1;
    }
}
.c-video-bg-box {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    right: 0;
    bottom: -72%;
    z-index: 1;
    opacity: 0.24;
}
.cd-video-inner {
    position: relative;
    width: 100%;
    video {
        width: 100%;
    }
    .video-mask {
        display: inline-block;
        width: 50%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        background-color: transparent;
        background-image: linear-gradient(90deg, #120b2c, transparent);
        &.is-02 {
            left: auto;
            right: 0;
            background-image: linear-gradient(90deg, transparent, #120b2c);
        }
    }
}
.c-experience-box {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 420px;
    text-align: center;
    position: relative;
    z-index: 22;
}
.cd-content-text {
    font-size: @title-font-size;
    color: #fff;
    & + .cd-button-box {
        margin-top: 64px;
    }
    br {
        display: none;
    }
    .is-import {
        color: @primary-color;
    }
}
@media only screen and (max-width: 1200px) {
    .cd-content-text {
        font-size: 32px;
    }
    .c-experience-box {
        min-height: 320px;
    }
    .cd-content-text {
        & + .cd-button-box {
            margin-top: 40px;
        }
    }
    .cd-button-box {
        .c-button {
            min-width: 160px;
        }
    }
    .c-video-bg-box {
        bottom: -94%;
    }
}
@media only screen and (max-width: 995px) {
    .cd-content-text {
        font-size: 24px;
    }
    .c-experience-box {
        min-height: 240px;
    }
    .cd-content-text {
        & + .cd-button-box {
            margin-top: 32px;
        }
    }
    .cd-button-box {
        .c-button {
            min-width: 144px;
        }
    }
    .c-video-bg-box {
        bottom: -125%;
    }
}
@media only screen and (max-width: 579px) {
    .cd-content-text {
        br {
            display: block;
        }
    }
}
</style>
